<!-- New Daily DPR 2026 sept -->
<template>
  <div class="animated fadeIn">
    <div class="font-bold mb-10">Daily DPR</div>
    <div class="box-mini mb-10">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-4">
            <table>
              <tr>
                <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                </td>
                <td>
                  <flat-pickr @on-change="changeRangeDate" :config="exportConfig" class="font-13" v-model="exportDates"
                    name="export_date_start"></flat-pickr>
                </td>
                <!-- Only Admin -->
                <td v-if="getRoleId == 1">
                  <a @click="!syncing && confirmSync()" class="btn-secondary ml-5" :class="{ disabled: syncing }">
                    <i class="fa fa-sync mr-5" :class="{ 'fa-spin': syncing }"></i>{{ syncing ? 'Syncing...' : 'Sync' }}
                  </a>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select :disabled="disableBranch" name="branch" v-model="branch_id" @change="changeBranch">
                  <option :value="null">Please select</option>
                  <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-4 text-right" v-if="hasEditPermission">
            <a @click="openPage('/dailyDPRGoals/index')" class="btn-secondary">Edit Daily DPR Goals</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15">
        <div class="col-12">
          <div class="overflow-auto">
            <!-- Category Membership -->
            <table class="table table-striped mb-0" v-if="branch_id != 3">

              <!-- Show if < 2026 -->
              <template v-if="year < 2026">
                <thead>
                  <tr class="text-center">
                    <th colspan="6">
                      Membership
                    </th>
                  </tr>
                  <tr class="text-center">
                    <th colspan="6">New Membership Sales <div v-if="loadingData"
                        class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden"></span>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th>Name</th>
                    <th>Day</th>
                    <th>Month</th>
                    <th>Projo</th>
                    <th>Goal</th>
                    <th>% club in bank</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Unit Membership</td>
                    <td>{{ membership.unit_membership_daily ? membership.unit_membership_daily : 0 }}</td>
                    <td>{{ membership.unit_membership_monthly ? membership.unit_membership_monthly : 0 }}</td>
                    <td>
                      <template v-if="isClosedDprPeriod">
                        {{ membership.projo }}
                      </template>
                      <template v-else-if="membership.unit_membership_monthly">
                        {{ roundValue((((membership.unit_membership_monthly / (getDay(searchDate))) *
                          totalDayInMonth(searchDate)) / getSingleGoal(3)) * 100) }}
                      </template>
                      <template v-else>
                        0
                      </template>
                    </td>
                    <td>{{ isClosedDprPeriod ? membership.goal : getSingleGoal(3) }}</td>
                    <td>{{ isClosedDprPeriod ? membership.club_in_bank : roundValue((membership.unit_membership_daily /
                      getSingleGoal(3)) *
                      100) }}%</td>
                  </tr>

                  <template v-if="new_daily_dpr">
                    <tr
                      v-for="dailydpr in (new_daily_dpr['Membership'] || []).filter(r => r.transaction_type !== 'Total')"
                      :key="dailydpr.transaction_type">
                      <td>{{ dailydpr.transaction_type }}</td>
                      <td> {{ parseCurrency(dailydpr.total_day) }}</td>
                      <td> {{ parseCurrency(dailydpr.total_month) }}</td>
                      <td>0</td>
                      <td>0</td>
                      <td>0</td>
                    </tr>
                  </template>

                  <tr class="hiddenx">
                    <th>Total</th>
                    <th> {{ parseCurrency(isClosedDprPeriod ? membershipTotalRow.total_day :
                      new_total_dpr.Membership_day) }} </th>
                    <th> {{ parseCurrency(isClosedDprPeriod ? membershipTotalRow.total_month :
                      new_total_dpr.Membership_month) }} </th>
                    <th>
                      <template v-if="isClosedDprPeriod">
                        {{ membershipTotalRow.projo }}
                      </template>
                      <template v-else-if="new_total_dpr.Membership">
                        {{ roundValue((((new_total_dpr.Membership / (getDay(searchDate))) * totalDayInMonth(searchDate))
                          / getSingleGoal(34)) * 100) }}
                      </template>
                      <template v-else>
                        0
                      </template>
                    </th>
                    <th>{{ parseCurrency(isClosedDprPeriod ? membershipTotalRow.goal : getSingleGoal(34)) }}</th>
                    <th>{{ isClosedDprPeriod ? membershipTotalRow.club_in_bank : roundValue((new_total_dpr.Membership /
                      getSingleGoal(34))
                      * 100) }}%</th>
                  </tr>
                </tbody>
              </template>

              <!-- Show if >= 2026 -->
              <template v-else>
                <thead>
                  <tr class="text-center">
                    <th colspan="6">Membership</th>
                  </tr>
                  <tr class="text-center">
                    <th colspan="6">New Membership Sales <div v-if="loadingData"
                        class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden"></span>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th>Name</th>
                    <th>Day</th>
                    <th>Month</th>
                    <th>Projo</th>
                    <th>Goal</th>
                    <th>% club in bank</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Unit Membership(Fresh + Rejoin Membership)</td>
                    <td>{{ membership.unit_membership_daily ? membership.unit_membership_daily : 0 }}</td>
                    <td>{{ membership.unit_membership_monthly ? membership.unit_membership_monthly : 0 }}</td>
                    <td>
                      <template v-if="isClosedDprPeriod">
                        {{ membership.projo }}
                      </template>
                      <template v-else-if="membership.unit_membership_monthly">
                        {{ roundValue((((membership.unit_membership_monthly / (getDay(searchDate))) *
                          totalDayInMonth(searchDate)) / getSingleGoal(3)) * 100) }}
                      </template>
                      <template v-else>
                        0
                      </template>
                    </td>
                    <td>{{ isClosedDprPeriod ? membership.goal : getSingleGoal(3) }}</td>
                    <td>{{ isClosedDprPeriod ? membership.club_in_bank : roundValue((membership.unit_membership_daily /
                      getSingleGoal(3)) *
                      100) }}%</td>
                  </tr>
                  <tr>
                    <td>Unit Membership(Continue)</td>
                    <td>{{ membership.unit_membership_continue_daily ? membership.unit_membership_continue_daily : 0 }}
                    </td>
                    <td>{{ membership.unit_membership_continue_monthly ? membership.unit_membership_continue_monthly : 0
                    }}
                    </td>
                    <td>
                      0
                    </td>
                    <td>
                      0
                    </td>
                    <td>
                      0
                    </td>
                  </tr>

                  <template v-if="new_daily_dpr">
                    <tr
                      v-for="dailydpr in (new_daily_dpr['Membership'] || []).filter(r => r.transaction_type !== 'Total')"
                      :key="dailydpr.transaction_type">
                      <td>{{ dailydpr.transaction_type }}</td>
                      <td> {{ parseCurrency(dailydpr.total_day) }}</td>
                      <td> {{ parseCurrency(dailydpr.total_month) }}</td>
                      <td>0</td>
                      <td>0</td>
                      <td>0</td>
                    </tr>
                  </template>

                  <tr class="hiddenx">
                    <th>Total</th>
                    <th> {{ parseCurrency(isClosedDprPeriod ? membershipTotalRow.total_day :
                      new_total_dpr.Membership_day) }} </th>
                    <th> {{ parseCurrency(isClosedDprPeriod ? membershipTotalRow.total_month :
                      new_total_dpr.Membership_month) }} </th>
                    <th>
                      <template v-if="isClosedDprPeriod">
                        {{ membershipTotalRow.projo }}
                      </template>
                      <template v-else-if="new_total_dpr.Membership">
                        {{ roundValue((((new_total_dpr.Membership / (getDay(searchDate))) * totalDayInMonth(searchDate))
                          / getSingleGoal(34)) * 100) }}
                      </template>
                      <template v-else>
                        0
                      </template>
                    </th>
                    <th>{{ parseCurrency(isClosedDprPeriod ? membershipTotalRow.goal : getSingleGoal(34)) }}</th>
                    <th>{{ isClosedDprPeriod ? membershipTotalRow.club_in_bank : roundValue((new_total_dpr.Membership /
                      getSingleGoal(34))
                      * 100) }}%</th>
                  </tr>
                </tbody>
              </template>

              <!-- Alpha Session -->
              <thead>
                <tr class="text-center">
                  <th colspan="6">ALPHA SESSION REVENUE</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(personalTraining, index) in new_daily_dpr['Personal Training']"
                  :key="personalTraining.transaction_type">
                  <template v-if="personalTraining.transaction_type == 'New Alpha Session'">
                    <td>{{ personalTraining.transaction_type }}</td>
                    <td> {{ parseCurrency(personalTraining.total) }}</td>
                    <td> {{ parseCurrency(personalTraining.total) }}</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                  </template>
                </tr>
                <tr>
                  <th>Total</th>
                  <th> {{ parseCurrency(isClosedDprPeriod ? alphaSessionTotalRow.total_day :
                    (sumDataNewDailyDPRNewAlphaSession(new_daily_dpr['Personal Training']) +
                    new_total_dpr.Membership)) }} </th>
                  <th> {{ parseCurrency(isClosedDprPeriod ? alphaSessionTotalRow.total_month :
                    (sumDataNewDailyDPRNewAlphaSession(new_daily_dpr['Personal Training']) +
                    new_total_dpr.Membership)) }} </th>
                  <th>
                    <template v-if="isClosedDprPeriod">
                      {{ alphaSessionTotalRow.projo }}
                    </template>
                    <template v-else-if="new_total_dpr.Membership">
                      {{ roundValue(((((sumDataNewDailyDPRNewAlphaSession(new_daily_dpr['Personal Training']) +
                        new_total_dpr.Membership) / (getDay(searchDate))) * totalDayInMonth(searchDate)) /
                        getSingleGoal(34)) * 100) }}
                    </template>
                    <template v-else>
                      0
                    </template>
                  </th>
                  <th>{{ parseCurrency(isClosedDprPeriod ? alphaSessionTotalRow.goal : getSingleGoal(34)) }}</th>
                  <th>{{ isClosedDprPeriod ? alphaSessionTotalRow.club_in_bank :
                    roundValue(((sumDataNewDailyDPRNewAlphaSession(new_daily_dpr['Personal Training']) +
                      new_total_dpr.Membership) / getSingleGoal(34)) * 100) }}%</th>
                </tr>
              </tbody>
              <!-- end Alpha Session -->

              <thead>
                <tr class="text-center">
                  <th colspan="6">Membership Contract Category</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> Fresh Membership</td>
                  <td> {{ membershipContractCategory.fresh_unit_membership_daily }} </td>
                  <td> {{ membershipContractCategory.fresh_unit_membership_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> Upgrade Membership</td>
                  <td> {{ membershipContractCategory.upgrade_unit_membership_daily }} </td>
                  <td> {{ membershipContractCategory.upgrade_unit_membership_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> Downgrade Membership</td>
                  <td> {{ membershipContractCategory.downgrade_unit_membership_daily }} </td>
                  <td> {{ membershipContractCategory.downgrade_unit_membership_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> Rejoin Membership</td>
                  <td> {{ membershipContractCategory.rejoin_unit_membership_daily }} </td>
                  <td> {{ membershipContractCategory.rejoin_unit_membership_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> Transfer Membership</td>
                  <td> {{ membershipContractCategory.transfer_unit_membership_daily }} </td>
                  <td> {{ membershipContractCategory.transfer_unit_membership_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> Continue Membership</td>
                  <td> {{ membershipContractCategory.change_membership_daily }} </td>
                  <td> {{ membershipContractCategory.change_membership_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>Total</th>
                  <th>
                    <template v-if="isClosedDprPeriod">
                      {{ membershipContractCategory.total_daily }}
                    </template>
                    <template v-else>
                      {{ sumData(membershipContractCategory.fresh_unit_membership_daily,
                        membershipContractCategory.upgrade_unit_membership_daily,
                        membershipContractCategory.downgrade_unit_membership_daily,
                        membershipContractCategory.rejoin_unit_membership_daily,
                        membershipContractCategory.transfer_unit_membership_daily)
                        + membershipContractCategory.change_membership_daily }}
                    </template>
                  </th>
                  <th>
                    <template v-if="isClosedDprPeriod">
                      {{ membershipContractCategory.total_monthly }}
                    </template>
                    <template v-else>
                      {{ sumData(membershipContractCategory.fresh_unit_membership_monthly,
                        membershipContractCategory.upgrade_unit_membership_monthly,
                        membershipContractCategory.downgrade_unit_membership_monthly,
                        membershipContractCategory.rejoin_unit_membership_monthly,
                        membershipContractCategory.transfer_unit_membership_monthly)
                        + membershipContractCategory.change_membership_monthly }}
                    </template>
                  </th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tbody>

              <!-- Membership by status — endpoint live-nya sendiri tidak difilter tanggal
                   (snapshot status member saat request), tapi untuk bulan closed dibaca dari
                   tabel histori (snapshot beku di waktu cron generate) supaya tidak diam-diam
                   berubah kalau status member terus berubah belakangan. -->
              <thead>
                <tr class="text-center" v-if="getRoleId == 1 || getRoleId == '1' || getRoleId == 35 || getRoleId == 34">
                  <th colspan="5">Total Membership by Status</th>
                  <th>
                    <a @click="exportReportTotalMembershipByStatus()" class="btn-primary mr-5"><i
                        class="far fa-file-alt mr-5"></i>Export</a>
                  </th>
                </tr>
                <tr class="text-center" v-if="getRoleId != 1 || getRoleId == 35 || getRoleId == 34">
                  <th colspan="6">Total Membership by Status</th>
                </tr>
                <tr>
                  <th>Status</th>
                  <th colspan="6">Total Member</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="status in totalMembershipByStatus" :key="status.membership_status.status">
                  <td>{{ status.membership_status.status }}</td>
                  <td colspan="6">{{ status.total }}</td>
                </tr>
                <tr v-if="branch_id == 3">
                  <th>Total Member PT DS</th>
                  <th>{{ totalActiveMember }}</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
                <tr v-if="branch_id == 1">
                  <th>Total Member PT SQ</th>
                  <th>{{ totalActiveMember }}</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tbody>
              <!-- End Membership by status -->

              <thead>
                <tr class="text-center">
                  <th colspan="6">Membership Type</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="types in membershipTypeFiltered" :key="types.membership_id">
                  <template v-if="types.unit_membership_type_monthly != 0">
                    <td> {{ ifMembershipNull(types.membership) }}</td>
                    <td> {{ types.unit_membership_type_daily }} </td>
                    <td> {{ types.unit_membership_type_monthly }} </td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                  </template>
                </tr>
                <tr>
                  <th>Total</th>
                  <th> {{ countTypeDaily(totalTypeDaily) }} </th>
                  <th> {{ countTypeMonthly(totalTypeMonthly) }} </th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tbody>

              <thead>
                <tr class="text-center">
                  <th colspan="6">One Time Membership</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="types in oneTimeMembership" :key="types.membership_id">
                  <td> {{ ifMembershipNull(types.membership) }}</td>
                  <td> {{ types.unit_membership_type_daily }} </td>
                  <td> {{ types.unit_membership_type_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>Total</th>
                  <th> {{ countTypeDaily(totalTypeDailyOneTimeMembership) }} </th>
                  <th> {{ countTypeMonthly(totalTypeMonthlyOneTimeMembership) }} </th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tbody>

              <thead>
                <tr class="text-center">
                  <th colspan="6">Production Performance</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> Appointment Booked </td>
                  <td> {{ prodPerformance2.appointment_booked_daily }} </td>
                  <td> {{ prodPerformance2.appointment_booked_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> Appointment Show </td>
                  <td> {{ prodPerformance2.appointment_show_daily }} </td>
                  <td> {{ prodPerformance2.appointment_show_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> Number Guest Pass Issued </td>
                  <td> {{ prodPerformance2.guest_pass_issued_daily }} </td>
                  <td> {{ prodPerformance2.guest_pass_issued_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> TI Book </td>
                  <td> {{ prodPerformance2.direct_call_booked_daily }} </td>
                  <td> {{ prodPerformance2.direct_call_booked_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> TI Call </td>
                  <td> {{ prodPerformance2.direct_call_daily }} </td>
                  <td> {{ prodPerformance2.direct_call_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> Total Web Leads </td>
                  <td> {{ prodPerformance2.total_web_leads_daily }} </td>
                  <td> {{ prodPerformance2.total_web_leads_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> Total Web Leads Books </td>
                  <td> {{ prodPerformance2.total_web_leads_booked_daily }} </td>
                  <td> {{ prodPerformance2.total_web_leads_booked_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> Total of Referrals </td>
                  <td> {{ prodPerformance2.total_referral_daily }} </td>
                  <td> {{ prodPerformance2.total_referral_monthly }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>Total</th>
                  <th> {{ totalProdDaily }} </th>
                  <th> {{ totalProdMonthy }} </th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tbody>
            </table>
            <!-- End Category Membership -->
          </div>
        </div>
      </div>
    </div>

    <div class="box-mini mb-10">
      <div class="p-15">
        <div class="col-12">
          <div class="overflow-auto">
            <table class="table table-striped mb-0">

              <thead>
                <tr class="text-center">
                  <th colspan="6">Personal Training</th>
                </tr>
                <tr class="text-center">
                  <th colspan="6">PERSONAL TRAINING REVENUE</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> Personal Training </td>
                  <td> {{ isClosedDprPeriod ? parseCurrency(personalTrainingRevenueRow.total_day) :
                    (new_daily_dpr_pt.day ?
                    parseCurrency(new_daily_dpr_pt.day) : 0) }} </td>
                  <td> {{ isClosedDprPeriod ? parseCurrency(personalTrainingRevenueRow.total_month) :
                    (new_daily_dpr_pt.month ? parseCurrency(new_daily_dpr_pt.month) : 0) }} </td>
                  <td>
                    <template v-if="isClosedDprPeriod">
                      {{ personalTrainingRevenueRow.projo }}
                    </template>
                    <template v-else-if="new_daily_dpr_pt.month">
                      {{ roundValue((((new_daily_dpr_pt.month / (getDay(searchDate))) * totalDayInMonth(searchDate)) /
                        getSingleGoal(33)) * 100) }}
                    </template>
                    <template v-else>
                      0
                    </template>
                  </td>
                  <td>{{ isClosedDprPeriod ? personalTrainingRevenueRow.goal : getSingleGoal(33) }}</td>
                  <td>{{ isClosedDprPeriod ? personalTrainingRevenueRow.club_in_bank :
                    roundValue((new_daily_dpr_pt.month /
                    getSingleGoal(33)) * 100) }}%</td>
                </tr>
                <tr>
                  <th>Total</th>
                  <th> {{ isClosedDprPeriod ? parseCurrency(personalTrainingRevenueRow.total_day) :
                    parseCurrency(new_daily_dpr_pt.day) }} </th>
                  <th> {{ isClosedDprPeriod ? parseCurrency(personalTrainingRevenueRow.total_month) :
                    parseCurrency(new_daily_dpr_pt.month) }} </th>
                  <th> </th>
                  <th> </th>
                  <th> </th>
                </tr>
              </tbody>

              <thead>
                <tr class="text-center">
                  <th colspan="6">ALPHA SESSION REVENUE</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="personalTraining in new_daily_dpr['Personal Training']"
                  :key="personalTraining.transaction_type + '-pt-alpha'">
                  <template
                    v-if="personalTraining.transaction_type == 'New Alpha Session' || personalTraining.transaction_type == 'Renew Alpha Session'">
                    <td>{{ personalTraining.transaction_type }}</td>
                    <td> {{ parseCurrency(personalTraining.total) }}</td>
                    <td> {{ parseCurrency(personalTraining.total) }}</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                  </template>
                </tr>
                <tr>
                  <th>Total</th>
                  <th> {{ parseCurrency(sumDataNewDailyDPR(new_daily_dpr['Personal Training'])) }} </th>
                  <th> {{ parseCurrency(sumDataNewDailyDPR(new_daily_dpr['Personal Training'])) }} </th>
                  <th> </th>
                  <th> </th>
                  <th> </th>
                </tr>
              </tbody>

              <thead>
                <tr class="text-center">
                  <th colspan="6">POS 1 & POS 2 REVENUE</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> POS 1 Revenue </td>
                  <td> {{ dataPtRow.pt_pos_1_day ? parseCurrency(dataPtRow.pt_pos_1_day) : 0 }} </td>
                  <td> {{ dataPtRow.pt_pos_1_month ? parseCurrency(dataPtRow.pt_pos_1_month) : 0 }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> POS 2 Revenue </td>
                  <td> {{ dataPtRow.pt_pos_2_day ? parseCurrency(dataPtRow.pt_pos_2_day) : 0 }} </td>
                  <td> {{ dataPtRow.pt_pos_2_month ? parseCurrency(dataPtRow.pt_pos_2_month) : 0 }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>Total</th>
                  <th> {{ parseCurrency(sumData(dataPtRow.pt_pos_1_day, dataPtRow.pt_pos_2_day)) }} </th>
                  <th> {{ parseCurrency(sumData(dataPtRow.pt_pos_1_month, dataPtRow.pt_pos_2_month)) }} </th>
                  <th> </th>
                  <th> </th>
                  <th> </th>
                </tr>
              </tbody>

              <thead>
                <tr class="text-center">
                  <th colspan="6">NEW & RENEW PERSONAL TRAINING SESSIONS</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> New Personal Training Sessions </td>
                  <td> {{ dataPtRow.new_pt_session_day ? parseCurrency(dataPtRow.new_pt_session_day) : 0 }} </td>
                  <td> {{ dataPtRow.new_pt_session_month ? parseCurrency(dataPtRow.new_pt_session_month) : 0 }} </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td> Renew Personal Training Sessions </td>
                  <td> {{ dataPtRow.renew_pt_session_day ? parseCurrency(dataPtRow.renew_pt_session_day) : 0 }} </td>
                  <td> {{ dataPtRow.renew_pt_session_month ? parseCurrency(dataPtRow.renew_pt_session_month) : 0 }}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th>Total</th>
                  <th> {{ parseCurrency(sumData(dataPtRow.new_pt_session_day, dataPtRow.renew_pt_session_day)) }} </th>
                  <th> {{ parseCurrency(sumData(dataPtRow.new_pt_session_month, dataPtRow.renew_pt_session_month)) }}
                  </th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tbody>

              <!-- Running Session -->
              <thead>
                <tr class="text-start">
                  <th></th>
                </tr>
              </thead>
              <thead>
                <tr class="text-center" v-if="getRoleId == 1 || getRoleId == '1'">
                  <th colspan="5">PT Running Session</th>
                  <th>
                    <a @click="exportReportPTRunning()" class="btn-primary mr-5"><i
                        class="far fa-file-alt mr-5"></i>Export</a>
                  </th>
                </tr>
                <tr class="text-center" v-if="getRoleId != 1">
                  <th colspan="6">PT Running Session</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> Running Session </td>
                  <td> {{ parseInt(running_session.running_daily).toLocaleString('id-ID', { maximumFractionDigits: 0 })
                  }}
                  </td>
                  <td> {{ parseInt(running_session.running_monthly).toLocaleString('id-ID', {
                    maximumFractionDigits: 0
                  }) }}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td> Free Running Session </td>
                  <td> {{ parseInt(running_session.free_running_daily).toLocaleString('id-ID',
                    { maximumFractionDigits: 0 }) }}
                  </td>
                  <td> {{ running_session.free_running_monthly }} </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td> Total Running Session </td>
                  <td> {{ sumDataRunningSession(running_session.running_daily,
                    running_session.free_running_daily).toLocaleString('id-ID', { maximumFractionDigits: 0 }) }} </td>
                  <td> {{ sumDataRunningSession(running_session.running_monthly,
                    running_session.free_running_monthly).toLocaleString('id-ID', { maximumFractionDigits: 0 }) }}</td>
                  <td>
                    <template v-if="isClosedDprPeriod">
                      {{ running_session.total_running_percent }}
                    </template>
                    <template v-else-if="running_session.running_monthly">
                      {{ roundValue(((((parseInt(running_session.running_monthly) +
                        parseInt(running_session.free_running_monthly)) / (getDay(searchDate))) *
                        totalDayInMonth(searchDate)) / getSingleGoal(36)) * 100) }}
                    </template>
                    <template v-else>
                      0
                    </template>
                  </td>
                  <td>{{ isClosedDprPeriod ? running_session.total_running_goal : getSingleGoal(36) }}</td>
                  <td>{{ isClosedDprPeriod ? running_session.total_running_percent :
                    (isFinite(running_session.running_monthly / getSingleGoal(36)) ?
                      roundValue(((parseInt(running_session.running_monthly) +
                        parseInt(running_session.free_running_monthly)) / getSingleGoal(36)) * 100) : 0) }}%</td>
                </tr>
                <tr>
                  <td colspan="6"></td>
                </tr>
                <tr>
                  <th>Revenue Running Session</th>
                  <th> {{ parseCurrency(running_session.revenue_running_daily) }} </th>
                  <th> {{ parseCurrency(running_session.revenue_running_monthly) }} </th>
                  <th>
                    <template v-if="isClosedDprPeriod">
                      {{ running_session.revenue_running_percent }}
                    </template>
                    <template v-else-if="running_session.revenue_running_monthly">
                      {{ roundValue((((running_session.revenue_running_monthly / (getDay(searchDate))) *
                        totalDayInMonth(searchDate)) / getSingleGoal(37)) * 100) }}
                    </template>
                    <template v-else>
                      0
                    </template>
                  </th>
                  <th>{{ isClosedDprPeriod ? parseCurrency(running_session.revenue_running_goal) :
                    parseCurrency(getSingleGoal(37)) }}</th>
                  <th>{{ isClosedDprPeriod ? running_session.revenue_running_percent :
                    (isFinite(roundValue((running_session.revenue_running_monthly / getSingleGoal(37)) * 100)) ?
                      roundValue((running_session.revenue_running_monthly / getSingleGoal(37)) * 100) : 0) }}%</th>
                </tr>
              </tbody>

              <!-- production personal trainer -->
              <thead>
                <tr class="text-center">
                  <th colspan="6">Production Personal Trainer</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th colspan="6">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Total Paket POS (By Qty Session)</td>
                  <td colspan="6">{{ production_personal_trainer.paket_pt[0].total_paket_pos }}</td>
                </tr>
                <tr>
                  <td>Total Paket POS (By Qty Package)</td>
                  <td colspan="6">{{ production_personal_trainer.paket_pt[0].total_paket_pos2 }}</td>
                </tr>
                <tr>
                  <td>Total Paket NEW (By Qty Session)</td>
                  <td colspan="6">{{ production_personal_trainer.paket_pt[0].total_paket_new }}</td>
                </tr>
                <tr>
                  <td>Total Paket NEW (By Qty Package)</td>
                  <td colspan="6">{{ production_personal_trainer.paket_pt[0].total_paket_new2 }}</td>
                </tr>
                <tr>
                  <td>Total Paket RENEW (By Qty Session)</td>
                  <td colspan="6">{{ production_personal_trainer.paket_pt[0].total_paket_renew }}</td>
                </tr>
                <tr>
                  <td>Total Paket RENEW (By Qty Package)</td>
                  <td colspan="6">{{ production_personal_trainer.paket_pt[0].total_paket_renew2 }}</td>
                </tr>
                <tr>
                  <td>PT Service</td>
                  <td colspan="6">{{ production_personal_trainer.paket_pt[0].pt_service }}</td>
                </tr>
                <tr>
                  <td>PHA Appointment</td>
                  <td colspan="6">{{ totalPHAappointment }}</td>
                </tr>
                <tr>
                  <td>PHA Show</td>
                  <td colspan="6">{{ production_personal_trainer.pha.pha_show }}</td>
                </tr>
                <tr>
                  <td>Total Member</td>
                  <td colspan="6">{{ production_personal_trainer.paket_pt[0].total_member }}</td>
                </tr>
                <tr>
                  <td>New Member</td>
                  <td colspan="6">{{ production_personal_trainer.paket_pt[0].new_member }}</td>
                </tr>
                <tr>
                  <td>Discontinue Member</td>
                  <td colspan="6">{{ production_personal_trainer.paket_pt[0].discontinue_member }}</td>
                </tr>
              </tbody>
              <!-- End production personal trainer -->
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="box-mini mb-10">
      <div class="p-15">
        <div class="col-12">
          <div class="overflow-auto">
            <table class="table table-striped mb-0" v-if="operation.length">
              <thead>
                <tr class="text-center">
                  <th colspan="6">Operation</th>
                </tr>
                <tr class="text-center">
                  <th colspan="6">Service Revenue</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(operation1) in new_daily_dpr['Operation']"
                  :key="'outstanding-' + operation1.transaction_type">
                  <template v-if="year <= 2026 && month < 4">
                    <template
                      v-if="operation1.transaction_type == 'Outstanding' || operation1.transaction_type == 'In Advance'">
                      <td>{{ operation1.transaction_type }}</td>
                      <td> {{ parseCurrency(operation1.total) }}</td>
                      <td> {{ parseCurrency(operation1.total) }}</td>
                      <td>0</td>
                      <td>0</td>
                      <td>0</td>
                    </template>
                  </template>
                  <template v-else>
                    <template
                      v-if="operation1.transaction_type == 'Outstanding Current Month' || operation1.transaction_type == 'Outstanding First Month'">
                      <td>
                        <button v-if="operation1.transaction_type == 'Outstanding Current Month'"
                          @click="openModalTargetDetail('Current Month')">
                          {{ operation1.transaction_type }}
                        </button>
                        <button v-if="operation1.transaction_type == 'Outstanding First Month'"
                          @click="openModalTargetDetail('First Month')">
                          {{ operation1.transaction_type }}
                        </button>
                      </td>
                      <td> {{ parseCurrency(operation1.total) }}</td>
                      <td> {{ parseCurrency(operation1.total) }}</td>
                      <td>
                        <template v-if="isClosedDprPeriod">
                          {{ operation1.projo }}
                        </template>
                        <template v-else-if="operation1.transaction_type == 'Outstanding Current Month'">
                          {{ roundValue((((operation1.total / (getDay(searchDate))) * totalDayInMonth(searchDate))
                            / target_collection.os_current_month) * 100) }}
                        </template>
                        <template v-else-if="operation1.transaction_type == 'Outstanding First Month'">
                          {{ roundValue((((operation1.total / (getDay(searchDate))) * totalDayInMonth(searchDate)) /
                            target_collection.os_last_month) * 100) }}
                        </template>
                      </td>
                      <td>
                        <template v-if="isClosedDprPeriod">
                          {{ parseCurrency(operation1.goal) }}
                        </template>
                        <template v-else-if="operation1.transaction_type == 'Outstanding Current Month'">
                          {{ parseCurrency(target_collection.os_current_month) }}
                        </template>
                        <template v-else-if="operation1.transaction_type == 'Outstanding First Month'">
                          {{ parseCurrency(target_collection.os_last_month) }}
                        </template>
                      </td>
                      <td>
                        <template v-if="isClosedDprPeriod">
                          {{ operation1.club_in_bank }}
                        </template>
                        <template v-else-if="operation1.transaction_type == 'Outstanding Current Month'">
                          {{ roundValue((operation1.total / target_collection.os_current_month) * 100) }}
                        </template>
                        <template v-else-if="operation1.transaction_type == 'Outstanding First Month'">
                          {{ roundValue((operation1.total / target_collection.os_last_month) * 100) }}
                        </template>
                      </td>
                    </template>
                  </template>
                </tr>

                <tr>
                  <th>Total</th>
                  <th> {{ isClosedDprPeriod ? parseCurrency(operationOutstandingTotalRow.total_day) :
                    parseCurrency(new_total_dpr.OperationOutstandingAdvanceDay) }} </th>
                  <th> {{ isClosedDprPeriod ? parseCurrency(operationOutstandingTotalRow.total_month) :
                    parseCurrency(new_total_dpr.OperationOutstandingAdvanceMonth) }} </th>
                  <th>
                    {{ isClosedDprPeriod ? operationOutstandingTotalRow.projo :
                      new_total_dpr.OperationOutstandingAdvanceProjo }}
                  </th>
                  <th>
                    {{ isClosedDprPeriod ? parseCurrency(operationOutstandingTotalRow.goal) :
                      parseCurrency(target_collection.os_current_month + target_collection.os_last_month) }}
                  </th>
                  <th>
                    {{ isClosedDprPeriod ? operationOutstandingTotalRow.club_in_bank :
                      new_total_dpr.OperationOutstandingAdvanceInBank }}
                  </th>
                </tr>

                <tr
                  v-for="(operation, index) in (new_daily_dpr['Operation'] || []).filter(r => r.transaction_type !== 'Total Outstanding Advance' && r.transaction_type !== 'Total')"
                  :key="operation.transaction_type + index">
                  <template v-if="year <= 2026 && month < 4">
                    <template v-if="operation.transaction_type != 'Outstanding' && operation.transaction_type != 'In Advance'
                      && operation.transaction_type != 'Outstanding Current Month'
                      && operation.transaction_type != 'Outstanding First Month'
                      && operation.transaction_type != 'Outstanding Last Month'">
                      <td>{{ operation.transaction_type }}</td>
                      <td> {{ parseCurrency(operation.total) }}</td>
                      <td> {{ parseCurrency(operation.total) }}</td>
                      <td>
                        <template v-if="isClosedDprPeriod">
                          {{ operation.projo }}
                        </template>
                        <template v-else-if="!(getSingleGoal(operation.daily_dpr_subcategory_id) == 0)">
                          {{ roundValue((((operation.total / (getDay(searchDate))) * totalDayInMonth(searchDate)) /
                            getSingleGoal(operation.daily_dpr_subcategory_id)) * 100) }}
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                      <td>
                        <template v-if="isClosedDprPeriod">
                          <template v-if="operation.transaction_type == 'Form Outstanding'">{{
                            parseCurrency(operation.goal) }}</template>
                          <template v-else>{{ operation.goal }}</template>
                        </template>
                        <template v-else>
                          <div v-if="operation.transaction_type == 'Form Outstanding'">
                            {{ parseCurrency(getSingleGoal(operation.daily_dpr_subcategory_id)) }}
                          </div>
                          <div v-else>
                            {{ getSingleGoal(operation.daily_dpr_subcategory_id) }}
                          </div>
                        </template>
                      </td>
                      <td>
                        <template v-if="isClosedDprPeriod">
                          {{ operation.club_in_bank }}%
                        </template>
                        <template v-else-if="!(getSingleGoal(operation.daily_dpr_subcategory_id) == 0)">
                          {{ roundValue((operation.total_day / getSingleGoal(operation.daily_dpr_subcategory_id)) * 100)
                          }}%
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                    </template>
                  </template>
                  <template v-else>
                    <template
                      v-if="operation.transaction_type != 'Outstanding Current Month' && operation.transaction_type != 'Outstanding First Month' && operation.transaction_type != 'Outstanding'">
                      <td>{{ operation.transaction_type }}</td>
                      <td> {{ parseCurrency(operation.total) }}</td>
                      <td> {{ parseCurrency(operation.total) }}</td>
                      <td>
                        <template v-if="isClosedDprPeriod">
                          {{ operation.projo }}
                        </template>
                        <template v-else-if="!(getSingleGoal(operation.daily_dpr_subcategory_id) == 0)">
                          {{ roundValue((((operation.total / (getDay(searchDate))) * totalDayInMonth(searchDate)) /
                            getSingleGoal(operation.daily_dpr_subcategory_id)) * 100) }}
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                      <td>
                        <template v-if="isClosedDprPeriod">
                          <template v-if="operation.transaction_type == 'Form Outstanding'">{{
                            parseCurrency(operation.goal) }}</template>
                          <template v-else>{{ operation.goal }}</template>
                        </template>
                        <template v-else>
                          <div v-if="operation.transaction_type == 'Form Outstanding'">
                            {{ parseCurrency(getSingleGoal(operation.daily_dpr_subcategory_id)) }}
                          </div>
                          <div v-else>
                            {{ getSingleGoal(operation.daily_dpr_subcategory_id) }}
                          </div>
                        </template>
                      </td>
                      <td>
                        <template v-if="isClosedDprPeriod">
                          {{ operation.club_in_bank }}%
                        </template>
                        <template v-else-if="!(getSingleGoal(operation.daily_dpr_subcategory_id) == 0)">
                          {{ roundValue((operation.total_day / getSingleGoal(operation.daily_dpr_subcategory_id)) * 100)
                          }}%
                        </template>
                        <template v-else>
                          0
                        </template>
                      </td>
                    </template>
                  </template>
                </tr>

                <tr>
                  <th>Total</th>
                  <th> {{ isClosedDprPeriod ? parseCurrency(operationGrandTotalRow.total_day) :
                    parseCurrency(new_total_dpr.Operation) }} </th>
                  <th> {{ isClosedDprPeriod ? parseCurrency(operationGrandTotalRow.total_month) :
                    parseCurrency(new_total_dpr.Operation) }} </th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tbody>

              <thead>
                <tr class="text-center">
                  <th colspan="6">AUTO PAY & COLLECTION</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody v-if="autoPay.length">
                <tr v-for="(autoPay1) in (new_daily_dpr['Auto Pay'] || []).filter(r => r.transaction_type !== 'Total')"
                  :key="autoPay1.transaction_type">
                  <td>{{ autoPay1.transaction_type }}</td>
                  <td> {{ parseCurrency(autoPay1.total) }}</td>
                  <td> {{ parseCurrency(autoPay1.total) }}</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <th>Total</th>
                  <th> {{ parseCurrency(new_total_dpr.Auto_Pay) }} </th>
                  <th> {{ parseCurrency(new_total_dpr.Auto_Pay) }} </th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tbody>

              <thead>
                <tr class="text-center">
                  <th colspan="6">Operation Production Performance</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(cancel, index) in cancelFreeze" :key="cancel.transaction_type_id + '-' + index">
                  <td> {{ cancel.transaction_type.name }} </td>
                  <td> {{ cancel.data_daily ? cancel.data_daily : 0 }} </td>
                  <td> {{ cancel.data_monthly ? cancel.data_monthly : 0 }} </td>
                  <td>
                    <template v-if="isClosedDprPeriod">
                      {{ cancel.projo }}
                    </template>
                    <template v-else>
                      {{ getSingleGoal(30 + index) == 0 ? 0 : (roundValue((((cancel.data_monthly / (getDay(searchDate)))
                        *
                        totalDayInMonth(searchDate)) / getSingleGoal(30 + index)) * 100)) }}
                    </template>
                  </td>
                  <td>
                    <template v-if="isClosedDprPeriod">
                      {{ parseCurrency(cancel.goal) }}
                    </template>
                    <template v-else-if="cancel.transaction_type.name == 'Cancellation'">
                      {{ getSingleGoal(31) == 0 ? 0 : getSingleGoal(31) }}
                    </template>
                    <template v-else-if="cancel.transaction_type.name == 'Form Freeze'">
                      {{ getSingleGoal(30) == 0 ? 0 : getSingleGoal(30) }}
                    </template>
                    <template v-else-if="cancel.transaction_type.name == 'Form Outstanding'">
                      {{ getSingleGoal(32) == 0 ? 0 : getSingleGoal(32) }}
                    </template>
                    <template v-else>
                      0
                    </template>
                  </td>
                  <td>
                    <template v-if="isClosedDprPeriod">
                      {{ cancel.club_in_bank }}%
                    </template>
                    <template v-else>
                      {{ getSingleGoal(30 + index) == 0 ? 0 : roundValue((cancel.data_monthly / getSingleGoal(30 +
                        index))
                        *
                      100) }}%
                    </template>
                  </td>
                </tr>
                <tr>
                  <th>Total</th>
                  <th> {{ totalCancelDaily }} </th>
                  <th> {{ totalCancelMonthly }} </th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tbody>

              <template v-if="year >= 2026">
                <!-- Operation Performance -->
                <thead>
                  <tr class="text-center">
                    <th colspan="6">Operation Performance</th>
                  </tr>
                  <tr>
                    <th>Name</th>
                    <th>Day</th>
                    <th>Month</th>
                    <th>Projo</th>
                    <th>Goal</th>
                    <th>% club in bank</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in operationPerformanceRows" :key="row.key" :class="{ 'text-center': row.isHeader }">
                    <template v-if="row.isHeader">
                      <th colspan="6">{{ row.label }}</th>
                    </template>
                    <template v-else>
                      <td> {{ row.item.transaction_type.name }} </td>
                      <td> {{ row.item.data_daily ? row.item.data_daily : 0 }} </td>
                      <td> {{ row.item.data_monthly ? row.item.data_monthly : 0 }} </td>
                      <td>0</td>
                      <td>0</td>
                      <td>0%</td>
                    </template>
                  </tr>
                  <!-- <tr>
                  <th>Total</th>
                  <th> {{ totalOperationPerformance.total_daily }} </th>
                  <th> {{ totalOperationPerformance.total_monthly }} </th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr> -->
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                </tbody>
              </template>

              <!-- Growth Performance -->
              <template v-if="year >= 2026">
                <thead>
                  <tr class="text-center">
                    <th colspan="6">Growth Performance</th>
                  </tr>
                  <tr>
                    <th>Name</th>
                    <th>Day</th>
                    <th>Month</th>
                    <th>Projo</th>
                    <th>Goal</th>
                    <th>% club in bank</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(cancel, index) in growthPerformance"
                    :key="cancel.transaction_type_id + '-growth-' + index">
                    <td> {{ cancel.transaction_type.name }} </td>
                    <td> {{ cancel.data_daily ? cancel.data_daily : 0 }} </td>
                    <td> {{ cancel.data_monthly ? cancel.data_monthly : 0 }} </td>
                    <td>
                      0
                    </td>
                    <td>
                      <template v-if="isClosedDprPeriod">
                        {{ parseCurrency(cancel.goal) }}
                      </template>
                      <template v-else-if="cancel.transaction_type.name == 'Cancellation'">
                        {{ getSingleGoal(31) == 0 ? 0 : getSingleGoal(31) }}
                      </template>
                      <template v-else>
                        0
                      </template>
                    </td>
                    <td>
                      <template v-if="isClosedDprPeriod">
                        {{ cancel.club_in_bank }}%
                      </template>
                      <template v-else>
                        {{ getSingleGoal(30 + index) == 0 ? 0 : roundValue((cancel.data_monthly / getSingleGoal(30 +
                          index)) * 100)
                        }}%
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <th>Total</th>
                    <th> {{ totalGrowthPerformance.total_daily }} </th>
                    <th> {{ totalGrowthPerformance.total_monthly }} </th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                </tbody>
              </template>

              <thead>
                <tr class="text-center">
                  <th colspan="6">Total Revenue</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Day</th>
                  <th>Month</th>
                  <th>Projo</th>
                  <th>Goal</th>
                  <th>% club in bank</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Total Revenue Club</td>
                  <td> {{ parseCurrency(totalRevenueClub.total_revenue_daily) }} </td>
                  <td> {{ parseCurrency(totalRevenueClub.total_revenue_monthly) }} </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="40" alt="">
        <br>
        <div class="title-loading color-white">Please wait...</div>
      </div>
    </div>

    <b-modal v-model="showModalTarget" modal-class="modal-custom-image" size="xl" hide-footer lazy
      title="Detail Target">
      <button class="btn btn-primary" @click="exportTargetDetail()">
        Export
      </button>
      <div class="table-responsive">
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Year</th>
              <th>Month</th>
              <th>Year</th>
              <th>Club</th>
              <th>TRX Date</th>
              <th>TRX ID</th>
              <th>Member ID</th>
              <th>Member Name</th>
              <th>Membership</th>
              <th>Transaction Type</th>
              <th>Period</th>
              <th>Periode</th>
              <th>Gross Amount</th>
              <th>Transaction Status</th>
              <th>Transaction Code</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item) in detailTarget" :key="item.trx_id">
              <td>{{ item.tahun }}</td>
              <td>{{ item.bulan }}</td>
              <td>{{ item.branch_id }}</td>
              <td>{{ item.club }}</td>
              <td>{{ item.trx_date }}</td>
              <td>{{ item.trx_id }}</td>
              <td>{{ item.member_id }}</td>
              <td>{{ item.member_name }}</td>
              <td>{{ item.membership }}</td>
              <td>{{ item.transaction_type }}</td>
              <td>{{ item.period }}</td>
              <td>{{ item.periode }}</td>
              <td>{{ parseCurrency(item.gross_amount) }}</td>
              <td>{{ item.transaction_status }}</td>
              <td>{{ item.transaction_status_code }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <b-modal v-model="showSyncModal" hide-footer hide-header-close no-close-on-backdrop no-close-on-esc
      title="Sync Data Daily DPR">
      <div class="text-center mb-10">
        <img :src="`/svg-loaders/oval.svg`" width="32" alt="">
      </div>
      <p class="text-center">{{ syncCurrentStepLabel }}</p>
      <b-progress :max="100" height="2rem">
        <b-progress-bar :value="syncProgressPercent" :label="syncProgressPercent + '%'"></b-progress-bar>
      </b-progress>
    </b-modal>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'

export default {
  name: 'newDailyDPR',
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      loadingData: false,
      dataGoals: [],
      membership: [],
      membershipContractCategory: [],
      totalMembershipByStatus: [],
      membershipType: [],
      oneTimeMembership: [],
      prodPerformance2: {},
      totalActiveMember: 0,
      getRoleId: Auth.Session.get().paradigm_role,
      dataBranch: [],
      branch_id: null,
      disableBranch: false,
      searchDate: moment(new Date()).format('YYYY-MM-DD'),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))],
      },
      exportDates: (moment().startOf('month').format('YYYY-MM-DD')) + ' to ' + (moment().endOf('month').format('YYYY-MM-DD')),
      new_daily_dpr: {},
      new_total_dpr: {
        Membership: 0,
        Membership_day: 0,
        Membership_month: 0,
        Operation: 0,
        OperationOutstandingAdvanceDay: 0,
        OperationOutstandingAdvanceMonth: 0,
        OperationOutstandingAdvanceProjo: '',
        OperationOutstandingAdvanceInBank: '',
        Auto_Pay: 0
      },
      new_daily_dpr_pt: {
        day: 0,
        month: 0
      },
      dataPt: [],
      running_session: {},
      production_personal_trainer: {},
      totalPHAappointment: 0,
      target_collection: {
        os_current_month: 0,
        os_last_month: 0,
        os_percent: 0
      },
      autoPay: [],
      cancelFreeze: [],
      growthPerformance: [],
      operationPerformance: [],
      totalRevenueClub: {},
      operation: [],
      syncing: false,
      showSyncModal: false,
      syncProgressPercent: 0,
      syncCurrentStepLabel: '',
      showModalTarget: false,
      detailTarget: [],
      targetDetailPeriode: null,
      year: moment().format('YYYY'),
      month: moment().format('M'),
      isClosedDprPeriod: false
    }
  },
  computed: {
    hasEditPermission() {
      let role = localStorage.getItem('paradigm_role')
      let user_id = localStorage.getItem('paradigm_id')
      if (user_id == '1071808') {
        return true
      } else {
        return ![3, 6, 7, 33].includes(parseInt(role))
      }
    },
    // Bulan closed: baris 'Total' final (goal/projo/club_in_bank sudah dihitung di cron,
    // bukan dikalkulasi lagi di sini) — lihat GET /view_daily_dpr_membership_history.
    membershipTotalRow() {
      const rows = this.new_daily_dpr['Membership'] || []
      return rows.find(r => r.transaction_type === 'Total') || { total_day: 0, total_month: 0, goal: 0, projo: 0, club_in_bank: 0 }
    },
    // Sama seperti membershipTotalRow, tapi untuk section Alpha Session — lihat
    // GET /view_daily_dpr_alpha_session_history.
    alphaSessionTotalRow() {
      const rows = this.new_daily_dpr['Personal Training'] || []
      return rows.find(r => r.transaction_type === 'Total') || { total_day: 0, total_month: 0, goal: 0, projo: 0, club_in_bank: 0 }
    },
    // Bulan closed: baris 'Personal Training' final (sum semua transaction_type di
    // category 'Personal Training') — disimpan oleh /generate_daily_dpr_alpha_session
    // di category yang sama, jadi ikut kebaca dari GET /view_daily_dpr_alpha_session_history.
    personalTrainingRevenueRow() {
      const rows = this.new_daily_dpr['Personal Training'] || []
      return rows.find(r => r.transaction_type === 'Personal Training') || { total_day: 0, total_month: 0, goal: 0, projo: 0, club_in_bank: 0 }
    },
    // Bulan closed: baris 'Total Outstanding Advance' & 'Total' final untuk section
    // Service Revenue — lihat GET /view_daily_dpr_operation_history.
    operationOutstandingTotalRow() {
      const rows = this.new_daily_dpr['Operation'] || []
      return rows.find(r => r.transaction_type === 'Total Outstanding Advance') || { total_day: 0, total_month: 0, goal: 0, projo: 0, club_in_bank: 0 }
    },
    operationGrandTotalRow() {
      const rows = this.new_daily_dpr['Operation'] || []
      return rows.find(r => r.transaction_type === 'Total') || { total_day: 0, total_month: 0, goal: 0, projo: 0, club_in_bank: 0 }
    },
    // Section "Cancellation & Freeze" (header-nya salah tulis "Production Performance"
    // di file lama — sudah diperbaiki di sini) — sum data_daily/data_monthly, sama
    // persis untuk live maupun history (keduanya angka final).
    totalCancelDaily() {
      let total = 0
      for (let i = 0; i < this.cancelFreeze.length; i++) {
        const element = this.cancelFreeze[i]
        if (element.data_daily) {
          total += Number(element.data_daily)
        }
      }
      return total
    },
    totalCancelMonthly() {
      let total = 0
      for (let i = 0; i < this.cancelFreeze.length; i++) {
        const element = this.cancelFreeze[i]
        if (element.data_monthly) {
          total += Number(element.data_monthly)
        }
      }
      return total
    },
    // Section "Growth Performance" — "Total Unit Membership" dikurangi semua baris lain,
    // sama persis untuk live maupun history.
    totalGrowthPerformance() {
      let total_daily = 0
      let total_monthly = 0
      let total_unit_daily = 0
      let total_unit_monthly = 0
      for (let i = 0; i < this.growthPerformance.length; i++) {
        const element = this.growthPerformance[i]
        if (element.transaction_type_id == 0) {
          if (element.data_daily) { total_unit_daily += Number(element.data_daily) }
          if (element.data_monthly) { total_unit_monthly += Number(element.data_monthly) }
        } else {
          if (element.data_daily) { total_daily += Number(element.data_daily) }
          if (element.data_monthly) { total_monthly += Number(element.data_monthly) }
        }
      }
      return {
        total_daily: total_unit_daily - total_daily,
        total_monthly: total_unit_monthly - total_monthly
      }
    },
    // Section "Operation Performance" — selipkan sub-header "Cancelled by Walk-in" /
    // "Cancelled by System" tepat sebelum baris 'Cancelled' masing-masing (dibedakan via
    // transaction_type_id karena nama baris sama-sama 'Cancelled', lihat sample/operation_perfomance_sample.png).
    operationPerformanceRows() {
      const rows = []
      for (const item of this.operationPerformance) {
        if (item.transaction_type_id === 93) {
          rows.push({ isHeader: true, label: 'Cancelled by Walk-in', key: item.transaction_type_id + '-operation-header' })
        } else if (item.transaction_type_id === 94) {
          rows.push({ isHeader: true, label: 'Cancelled by System', key: item.transaction_type_id + '-operation-header' })
        }
        rows.push({ isHeader: false, item, key: item.transaction_type_id + '-operation' })
      }
      return rows
    },
    // Section "Operation Performance" — total murni sum semua baris (bukan pengurangan
    // seperti Growth Performance), karena semua barisnya snapshot/counter, bukan flow.
    totalOperationPerformance() {
      let total_daily = 0
      let total_monthly = 0
      for (let i = 0; i < this.operationPerformance.length; i++) {
        const element = this.operationPerformance[i]
        if (element.data_daily) { total_daily += Number(element.data_daily) }
        if (element.data_monthly) { total_monthly += Number(element.data_monthly) }
      }
      return {
        total_daily,
        total_monthly
      }
    },
    // Section POS 1 & POS 2 REVENUE + NEW & RENEW PERSONAL TRAINING SESSIONS — live dan
    // history (GET /daily_dpr_pt / /daily_dpr_pt_history) sama-sama mengembalikan array
    // berisi 1 object, jadi tidak perlu isClosedDprPeriod branching di sini.
    dataPtRow() {
      return this.dataPt[0] || {}
    },
    membershipTypeFiltered() {
      return this.membershipType.filter(types => types.membership_id != 27 && types.membership_id != 15)
    },
    totalTypeDaily() {
      return this.membershipTypeFiltered.filter(types => types.unit_membership_type_daily)
    },
    totalTypeMonthly() {
      return this.membershipTypeFiltered.filter(types => types.unit_membership_type_monthly)
    },
    totalTypeDailyOneTimeMembership() {
      return this.oneTimeMembership.filter(types => types.unit_membership_type_daily)
    },
    totalTypeMonthlyOneTimeMembership() {
      return this.oneTimeMembership.filter(types => types.unit_membership_type_monthly)
    },
    totalProdMonthy() {
      var apptsShow = this.prodPerformance2.appointment_show_monthly
      var apptsBooked = this.prodPerformance2.appointment_booked_monthly
      var guestIssued = this.prodPerformance2.guest_pass_issued_monthly
      var directCall = this.prodPerformance2.direct_call_monthly
      var directCallBooked = this.prodPerformance2.direct_call_booked_monthly
      var webLeads = this.prodPerformance2.total_web_leads_monthly
      var webLeadsBooked = this.prodPerformance2.total_web_leads_booked_monthly
      var totalReferral = this.prodPerformance2.total_referral_monthly
      return apptsShow + apptsBooked + guestIssued + directCall + directCallBooked + webLeads + webLeadsBooked + totalReferral
    },
    totalProdDaily() {
      var apptsShow = this.prodPerformance2.appointment_show_daily
      var apptsBooked = this.prodPerformance2.appointment_booked_daily
      var guestIssued = this.prodPerformance2.guest_pass_issued_daily
      var directCall = this.prodPerformance2.direct_call_daily
      var directCallBooked = this.prodPerformance2.direct_call_booked_daily
      var webLeads = this.prodPerformance2.total_web_leads_daily
      var webLeadsBooked = this.prodPerformance2.total_web_leads_booked_daily
      var totalReferral = this.prodPerformance2.total_referral_daily
      return apptsShow + apptsBooked + guestIssued + directCall + directCallBooked + webLeads + webLeadsBooked + totalReferral
    }
  },
  methods: {
    changeRangeDate(selectedDates, dateStr, instance) {
      if (selectedDates.length === 2) {
        if (typeof selectedDates[0] === typeof selectedDates[1]) {
          this.exportDates = dateStr + ' to ' + dateStr
        } else {
          this.exportDates = dateStr
        }
        if (this.exportDates.includes(" to ") === true) {
          this.fetchData()
        }

        // add year
        this.year = moment(new Date(selectedDates[0])).format('YYYY')
        // add month
        this.month = moment(new Date(selectedDates[0])).format('M')
      }
    },
    parseCurrency(event) {
      var data = parseInt(event)
      return 'Rp. ' + data.toLocaleString('id-ID', { maximumFractionDigits: 0 })
    },
    totalDayInMonth(value) {
      var month = moment(new Date(value)).format('M')
      var year = moment(new Date(value)).format('YYYY')
      return new Date(year, month, 0).getDate()
    },
    getDay(value) {
      var today = moment(new Date()).format('YYYY-MM')
      var selectedDay = this.exportDates.split(' to ')
      if (moment(selectedDay[0]).format('YYYY-MM') == today) {
        if (moment(new Date(value)).format('D') == 1) {
          return 2
        } else {
          return moment(new Date(value)).format('D')
        }
      } else {
        // total day in month
        return moment(new Date(value)).daysInMonth()
      }
    },
    roundValue(value) {
      return parseFloat(value).toFixed(2)
    },
    getSingleGoal(event) {
      var itemGoal = this.dataGoals.filter(item => item.daily_dpr_subcategory_id == event)
      if (itemGoal.length > 1) {
        let preResult = 0;
        for (const item of itemGoal) {
          preResult += parseFloat(item.goal);
        }
        return preResult;
      }
      return (itemGoal.length) ? itemGoal[0].goal : 0
    },
    sumDataNewDailyDPRNewAlphaSession(data) {
      let total = 0
      for (let index = 0; index < data.length; index++) {
        const el = data[index];
        if (el.transaction_type == 'New Alpha Session') {
          total += el.total
        }
      }

      return total
    },
    sumDataNewDailyDPR(data) {
      let total = 0
      for (let index = 0; index < data.length; index++) {
        const el = data[index];
        if (el.transaction_type == 'New Alpha Session' || el.transaction_type == 'Renew Alpha Session') {
          total += el.total
        }
      }

      return total
    },
    sumData(event1, event2, event3, event4, event5) {
      if (event1 || event2) {
        var data1 = event1 ? event1 : 0
        var data2 = event2 ? event2 : 0
        var data3 = event3 ? event3 : 0
        var data4 = event4 ? event4 : 0
        var data5 = event5 ? event5 : 0
        return parseInt(data1) + parseInt(data2) + parseInt(data3) + parseInt(data4) + parseInt(data5)
      } else {
        return 0
      }
    },
    sumDataRunningSession(val1, val2) {
      if (val1 || val2) {
        var data1 = val1 ? val1 : 0
        var data2 = val2 ? val2 : 0
        return parseInt(data1) + parseInt(data2)
      } else {
        return 0
      }
    },
    exportReportPTRunning() {
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/export/daily_dpr/pt_running_session?start_date=' + dates[0] + '&end_date=' + dates[1]

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'PT Running Session (Daily DPR) ' + moment(dates[0]).format('DD MMM YYYY') + ' - ' + moment(dates[1]).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    // Reuse logic dari dailyDPR.vue — hitung new_total_dpr.OperationOutstandingAdvance*
    // (Total row section Service Revenue) dari new_daily_dpr['Operation'] + target_collection.
    // Field OperationGoal/totalGoal di file lama tidak dipakai di template manapun jadi
    // sengaja tidak direplikasi di sini.
    calcTotalGoalOperation() {
      const data = this.new_daily_dpr['Operation'] || []
      let OperationOutstandingAdvanceDay = 0
      let OperationOutstandingAdvanceMonth = 0
      for (let i = 0; i < data.length; i++) {
        const element = data[i]
        if (this.year <= 2026 && this.month < 4) {
          if (element.transaction_type == 'Outstanding' || element.transaction_type == 'In Advance') {
            OperationOutstandingAdvanceDay += element.total_day
            OperationOutstandingAdvanceMonth += element.total_month
          }
        } else {
          if (element.transaction_type == 'Outstanding Current Month' || element.transaction_type == 'Outstanding First Month') {
            OperationOutstandingAdvanceDay += element.total_day
            OperationOutstandingAdvanceMonth += element.total_month
          }
        }
      }

      const projoFirstMonth = ((OperationOutstandingAdvanceMonth / (this.getDay(this.searchDate))) * this.totalDayInMonth(this.searchDate) / (this.target_collection.os_current_month + this.target_collection.os_last_month)) * 100
      this.new_total_dpr.OperationOutstandingAdvanceProjo = this.roundValue(projoFirstMonth)

      this.new_total_dpr.OperationOutstandingAdvanceInBank = this.roundValue((OperationOutstandingAdvanceMonth / (this.target_collection.os_current_month + this.target_collection.os_last_month)) * 100)
      if (this.new_total_dpr.OperationOutstandingAdvanceInBank == Infinity || isNaN(this.new_total_dpr.OperationOutstandingAdvanceInBank)) {
        this.new_total_dpr.OperationOutstandingAdvanceInBank = 0
      }

      this.new_total_dpr.OperationOutstandingAdvanceDay = OperationOutstandingAdvanceDay
      this.new_total_dpr.OperationOutstandingAdvanceMonth = OperationOutstandingAdvanceMonth
    },
    // Modal detail Target Collection. Kedua tombol ("Outstanding Current Month" &
    // "Outstanding First Month") sekarang sudah bisa buka modal, dan backend sudah
    // difilter per periode (lihat fix di GET /sales_report/daily_dpr_target_collection_detail
    // & GET /export/daily_dpr_target_collection_detail) — targetDetailPeriode dicatat
    // di sini supaya tombol Export di dalam modal ikut mengekspor periode yang sama
    // dengan yang sedang ditampilkan.
    openModalTargetDetail(ev) {
      this.showModalTarget = true
      this.targetDetailPeriode = ev
      let dates = this.exportDates.split(' to ')
      dates[1] = dates[1] == undefined ? dates[0] : dates[1]

      let url = 'crm/v1/sales_report/daily_dpr_target_collection_detail?tahun=' + moment(dates[0]).format('YYYY') + '&bulan=' + moment(dates[1]).format('MM')
      url += '&periode=' + ev
      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }
      this.loadingActive = true
      axios.get(url).then(response => {
        this.detailTarget = response.data.data
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    exportTargetDetail() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/export/daily_dpr_target_collection_detail?tahun=' + moment(dates[0]).format('YYYY') + '&bulan=' + moment(dates[1]).format('MM')

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }
      if (this.targetDetailPeriode != null) {
        url += '&periode=' + this.targetDetailPeriode
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Target Collection (Daily DPR) ' + moment(dates[0]).format('DD MMM YYYY') + ' - ' + moment(dates[1]).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    ifMembershipNull(value) {
      var data = value
      var replaceValue = ''
      if (data === null) {
        replaceValue = ''
      }
      else {
        replaceValue = data.name
      }
      return replaceValue
    },
    countTypeMonthly(value) {
      var total = 0
      for (var i = 0; i < value.length; i++) {
        total += value[i].unit_membership_type_monthly
      }
      return total
    },
    countTypeDaily(value) {
      var total = 0
      for (var i = 0; i < value.length; i++) {
        total += value[i].unit_membership_type_daily
      }
      return total
    },
    exportReportTotalMembershipByStatus() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/export/daily_dpr/total_membership_by_status?start_date=' + dates[0] + '&end_date=' + dates[1]

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Total Membership By Status (Daily DPR) ' + moment(dates[0]).format('DD MMM YYYY') + ' - ' + moment(dates[1]).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })
    },
    exportReport() {
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/export/sales_report/daily_dpr?start=' + dates[0] + '&end=' + dates[1]

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Sales Report (Daily DPR) ' + moment(dates[0]).format('DD MMM YYYY') + ' - ' + moment(dates[1]).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    // Tombol "Sync" — generate ulang semua data daily_dpr (15 category/section) untuk
    // period dari tanggal yang lagi dipilih di date-picker. Insert-only per category
    // sebenarnya sudah dijamin masing-masing endpoint generate_daily_dpr_*, tapi di sini
    // dicek dulu di depan (satu kali, level period) supaya user dapat pesan error yang
    // jelas kalau period-nya sudah pernah di-generate, bukannya diam-diam sebagian
    // ke-skip per category.
    confirmSync() {
      let dates = this.exportDates.split(' to ')
      const period = moment(dates[0]).format('YYYY-MM')

      // Sync cuma untuk bulan yang sudah closed (period sebelum bulan berjalan) — data
      // bulan berjalan masih terus berubah, tidak boleh dibekukan ke daily_dpr.
      if (period >= moment().format('YYYY-MM')) {
        this.$swal('Tidak bisa Sync', 'Sync cuma bisa dilakukan untuk period sebelumnya (bulan yang sudah closed), bukan bulan berjalan.', 'error')
        return
      }

      this.$swal({
        title: 'Sync Data Daily DPR?',
        text: 'Ini akan generate data Daily DPR untuk period ' + period + ' ke table history. Data yang sudah ada tidak akan ditimpa.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, Sync',
        cancelButtonText: 'Batal',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          this.runSync(period)
        }
      })
    },
    async runSync(period) {
      this.syncing = true
      this.loadingActive = true
      try {
        const checkResponse = await axios.get('crm/v1/cron/check_daily_dpr_period_exists?period=' + period)
        if (checkResponse.data.data.exists) {
          this.syncing = false
          this.loadingActive = false
          this.$swal('Gagal', 'Period yang dipilih sudah ada, segera hub admin', 'error')
          return
        }
      } catch (error) {
        this.syncing = false
        this.loadingActive = false
        this.$swal('Gagal', 'Gagal mengecek status period, coba lagi', 'error')
        console.log('error', error)
        return
      }

      const steps = [
        { path: 'crm/v1/cron/generate_daily_dpr_membership', label: 'Membership' },
        { path: 'crm/v1/cron/generate_daily_dpr_alpha_session', label: 'Alpha Session & Personal Training Revenue' },
        { path: 'crm/v1/cron/generate_daily_dpr_pt_sessions', label: 'POS 1 & 2 / New & Renew PT Sessions' },
        { path: 'crm/v1/cron/generate_daily_dpr_pt_running_session', label: 'PT Running Session' },
        { path: 'crm/v1/cron/generate_daily_dpr_production_personal_trainer', label: 'Production Personal Trainer' },
        { path: 'crm/v1/cron/generate_daily_dpr_membership_contract_category', label: 'Membership Contract Category' },
        { path: 'crm/v1/cron/generate_daily_dpr_membership_by_status', label: 'Total Membership by Status' },
        { path: 'crm/v1/cron/generate_daily_dpr_membership_type', label: 'Membership Type' },
        { path: 'crm/v1/cron/generate_daily_dpr_one_time_membership_type', label: 'One Time Membership' },
        { path: 'crm/v1/cron/generate_daily_dpr_production_performance', label: 'Production Performance' },
        { path: 'crm/v1/cron/generate_daily_dpr_operation', label: 'Service Revenue (Operation)' },
        { path: 'crm/v1/cron/generate_daily_dpr_auto_pay', label: 'Auto Pay & Collection' },
        { path: 'crm/v1/cron/generate_daily_dpr_cancellation_freeze', label: 'Cancellation & Freeze' },
        { path: 'crm/v1/cron/generate_daily_dpr_growth_performance', label: 'Growth Performance' },
        { path: 'crm/v1/cron/generate_daily_dpr_operation_performance', label: 'Operation Performance' },
        { path: 'crm/v1/cron/generate_daily_dpr_total_revenue', label: 'Total Revenue' }
      ]

      this.loadingActive = false
      this.showSyncModal = true
      this.syncProgressPercent = 0

      for (let i = 0; i < steps.length; i++) {
        this.syncCurrentStepLabel = steps[i].label
        try {
          await axios.get(steps[i].path + '?period=' + period)
        } catch (error) {
          console.log('error', error)
          this.syncing = false
          this.showSyncModal = false
          this.$swal('Gagal', 'Sync terhenti di step "' + steps[i].label + '". Silakan cek log server.', 'error')
          return
        }
        this.syncProgressPercent = Math.round(((i + 1) / steps.length) * 100)
      }

      this.syncing = false
      this.showSyncModal = false
      this.$swal('Berhasil', 'Sync data Daily DPR untuk period ' + period + ' selesai.', 'success')
      this.fetchData()
    },
    openPage(event) {
      this.$router.push(event)
    },
    changeBranch(event) {
      if (event != null) {
        this.branch_id = event
      }
      this.fetchData()
    },
    async fetchData() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      dates[1] = dates[1] == undefined ? dates[0] : dates[1]

      // Bulan yang sudah lewat dibaca dari tabel histori daily_dpr HANYA kalau periode itu
      // sudah pernah di-Sync (datanya benar-benar ada) — kalau belum di-Sync, baca live
      // sama seperti bulan berjalan (daripada nampilin 0/kosong dari daily_dpr yang belum
      // terisi). Dicek ke check_daily_dpr_period_exists dulu sebelum tentukan sumber data.
      const dprPeriod = moment(dates[0]).format('YYYY-MM')
      let periodExists = false
      if (dprPeriod < moment().format('YYYY-MM')) {
        try {
          const periodCheck = await axios.get('crm/v1/cron/check_daily_dpr_period_exists?period=' + dprPeriod)
          periodExists = !!periodCheck.data.data.exists
        } catch (error) {
          console.log('error', error)
        }
      }
      const isClosedDprPeriod = periodExists
      this.isClosedDprPeriod = isClosedDprPeriod

      let daily_dpr_membership_url = isClosedDprPeriod
        ? 'crm/v1/sales_report/daily_dpr_membership_history?period=' + dprPeriod
        : 'crm/v1/sales_report/daily_dpr_membership?start=' + dates[0] + '&end=' + dates[1]

      let daily_dpr_membership_contract_category_url = isClosedDprPeriod
        ? 'crm/v1/sales_report/daily_dpr_membership_contract_category_history?period=' + dprPeriod
        : 'crm/v1/sales_report/daily_dpr_membership_contract_category?start=' + dates[0] + '&end=' + dates[1]

      let daily_dpr = 'crm/v1/daily_dpr_goals?start=' + dates[0]

      if (this.branch_id != null) {
        daily_dpr_membership_url += '&branch_id=' + this.branch_id
        daily_dpr_membership_contract_category_url += '&branch_id=' + this.branch_id
        daily_dpr += '&branch_id=' + this.branch_id
      }

      axios.get(daily_dpr_membership_url).then(response => {
        this.membership = response.data[0]
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      axios.get(daily_dpr_membership_contract_category_url).then(response => {
        this.membershipContractCategory = response.data
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      axios.get(daily_dpr).then(response => {
        this.loadingActive = false
        this.dataGoals = response.data.data.rows
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.loadingActive = false
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      // Membership by status — endpoint live-nya sendiri tidak difilter tanggal (snapshot
      // status member saat request), tapi untuk bulan closed tetap dibaca dari histori
      // supaya tidak diam-diam berubah kalau status member di-update belakangan.
      let daily_dpr_membership_by_status_url = isClosedDprPeriod
        ? 'crm/v1/sales_report/daily_dpr_membership_by_status_history?period=' + dprPeriod
        : 'crm/v1/sales_report/daily_dpr_membership_total_by_status?branch_id=' + this.branch_id
      if (isClosedDprPeriod && this.branch_id != null) {
        daily_dpr_membership_by_status_url += '&branch_id=' + this.branch_id
      }
      axios.get(daily_dpr_membership_by_status_url).then(response => {
        this.loadingActive = false
        this.totalMembershipByStatus = response.data.data
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      let daily_dpr_membership_type_url = isClosedDprPeriod
        ? 'crm/v1/sales_report/daily_dpr_membership_type_history?period=' + dprPeriod
        : 'crm/v1/sales_report/daily_dpr_membership_type?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        daily_dpr_membership_type_url += '&branch_id=' + this.branch_id
      }
      axios.get(daily_dpr_membership_type_url).then(response => {
        this.membershipType = response.data
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      let daily_dpr_one_time_membership_type_url = isClosedDprPeriod
        ? 'crm/v1/sales_report/daily_dpr_one_time_membership_type_history?period=' + dprPeriod
        : 'crm/v1/sales_report/daily_dpr_one_time_membership_type?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        daily_dpr_one_time_membership_type_url += '&branch_id=' + this.branch_id
      }
      axios.get(daily_dpr_one_time_membership_type_url).then(response => {
        this.oneTimeMembership = response.data
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      let daily_dpr_production_performance_url = isClosedDprPeriod
        ? 'crm/v1/sales_report/daily_dpr_production_performance_history?period=' + dprPeriod
        : 'crm/v1/sales_report/daily_dpr_production_performance?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        daily_dpr_production_performance_url += '&branch_id=' + this.branch_id
      }
      axios.get(daily_dpr_production_performance_url).then(response => {
        this.prodPerformance2 = response.data[0]
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      // POS 1 & POS 2 REVENUE + NEW & RENEW PERSONAL TRAINING SESSIONS
      let daily_dpr_pt_url = isClosedDprPeriod
        ? 'crm/v1/sales_report/daily_dpr_pt_history?period=' + dprPeriod
        : 'crm/v1/sales_report/daily_dpr_pt?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        daily_dpr_pt_url += '&branch_id=' + this.branch_id
      }
      axios.get(daily_dpr_pt_url).then(response => {
        this.dataPt = response.data
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      // PT Running Session
      let daily_dpr_running_session_url = isClosedDprPeriod
        ? 'crm/v1/sales_report/daily_dpr_running_session_history?period=' + dprPeriod
        : 'crm/v1/sales_report/daily_dpr_running_session?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        daily_dpr_running_session_url += '&branch_id=' + this.branch_id
      }
      axios.get(daily_dpr_running_session_url).then(response => {
        this.running_session = response.data.data
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      // Production Personal Trainer
      let daily_dpr_production_personal_trainer_url = isClosedDprPeriod
        ? 'crm/v1/sales_report/daily_dpr_production_personal_trainer_history?period=' + dprPeriod
        : 'crm/v1/sales_report/daily_dpr_production_personal_trainer?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        daily_dpr_production_personal_trainer_url += '&branch_id=' + this.branch_id
      }
      axios.get(daily_dpr_production_personal_trainer_url).then(response => {
        this.production_personal_trainer = response.data.data
        if (isClosedDprPeriod) {
          this.totalPHAappointment = response.data.data.pha_appointment
        }
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      if (!isClosedDprPeriod) {
        const datePlanner = !this.dateTodayData ? dates[0] : this.dateTodayData
        axios.get("crm/v1/pt_planner/php-appointment/detail?date=" + datePlanner +
          "&branch_id=" + this.branch_id
        ).then((response) => {
          this.loadingActive = false
          this.totalPHAappointment = response.data.data.rows.length;
        }).catch((error) => {
          this.loadingActive = false
          console.log("error", error);
        });
      }

      axios.get('fitness/v1/personal_training/my_member_new_count?pt_id=&date=' + this.dateTodayData + '&branch_id=' + this.branch_id).then(response => {
        this.loadingActive = false
        this.totalActiveMember = response.data.data.total_member
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      // new daily dpr — baris nominal per transaction_type untuk category 'Membership'
      this.loadingData = true
      let viewDailyDprUrl = 'crm/v1/sales_report/view_daily_dpr_new?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        viewDailyDprUrl += '&branch_id=' + this.branch_id
      }

      axios.get(viewDailyDprUrl).then(async response => {
        this.loadingData = false
        this.new_total_dpr.Membership = 0
        this.new_total_dpr.Membership_day = 0
        this.new_total_dpr.Membership_month = 0
        this.new_total_dpr.Operation = 0
        this.new_total_dpr.Auto_Pay = 0

        const data = response.data.data

        // Bulan closed: timpa baris Membership, Personal Training (Alpha Session),
        // Operation, & Auto Pay dengan histori dari tabel daily_dpr.
        if (isClosedDprPeriod) {
          try {
            let membershipHistoryUrl = 'crm/v1/sales_report/view_daily_dpr_membership_history?period=' + dprPeriod
            if (this.branch_id != null) {
              membershipHistoryUrl += '&branch_id=' + this.branch_id
            }
            const membershipHistoryResponse = await axios.get(membershipHistoryUrl)
            data['Membership'] = membershipHistoryResponse.data.data
          } catch (error) {
            console.log('error fetching membership dpr history', error)
          }

          try {
            let alphaSessionHistoryUrl = 'crm/v1/sales_report/view_daily_dpr_alpha_session_history?period=' + dprPeriod
            if (this.branch_id != null) {
              alphaSessionHistoryUrl += '&branch_id=' + this.branch_id
            }
            const alphaSessionHistoryResponse = await axios.get(alphaSessionHistoryUrl)
            data['Personal Training'] = alphaSessionHistoryResponse.data.data
          } catch (error) {
            console.log('error fetching alpha session dpr history', error)
          }

          try {
            let operationHistoryUrl = 'crm/v1/sales_report/view_daily_dpr_operation_history?period=' + dprPeriod
            if (this.branch_id != null) {
              operationHistoryUrl += '&branch_id=' + this.branch_id
            }
            const operationHistoryResponse = await axios.get(operationHistoryUrl)
            data['Operation'] = operationHistoryResponse.data.data
          } catch (error) {
            console.log('error fetching operation dpr history', error)
          }

          try {
            let autoPayHistoryUrl = 'crm/v1/sales_report/view_daily_dpr_auto_pay_history?period=' + dprPeriod
            if (this.branch_id != null) {
              autoPayHistoryUrl += '&branch_id=' + this.branch_id
            }
            const autoPayHistoryResponse = await axios.get(autoPayHistoryUrl)
            data['Auto Pay'] = autoPayHistoryResponse.data.data
          } catch (error) {
            console.log('error fetching auto pay dpr history', error)
          }
        }

        const membershipRows = data['Membership'] || []
        for (let i = 0; i < membershipRows.length; i++) {
          const element = membershipRows[i]
          this.new_total_dpr.Membership += element.total
          this.new_total_dpr.Membership_day += element.total_day
          this.new_total_dpr.Membership_month += element.total_month
        }

        // new_total_dpr.Operation/Auto_Pay — sum element.total (quirk: dipakai sebagai
        // satu nilai yang sama untuk kolom Day & Month di baris Total masing-masing
        // section), reuse logic loop "for (const key in data)" di dailyDPR.vue.
        const operationRows = data['Operation'] || []
        for (let i = 0; i < operationRows.length; i++) {
          this.new_total_dpr.Operation += operationRows[i].total
        }
        const autoPayRows = data['Auto Pay'] || []
        for (let i = 0; i < autoPayRows.length; i++) {
          this.new_total_dpr.Auto_Pay += autoPayRows[i].total
        }

        this.new_daily_dpr = data
        this.calcTotalGoalOperation()

        // baris "Personal Training" (section PERSONAL TRAINING REVENUE) — jumlah SEMUA
        // transaction_type di category 'Personal Training', sama seperti new_daily_dpr_pt
        // di dailyDPR.vue. Untuk bulan closed nilai ini tidak dipakai di template
        // (dipakai langsung dari personalTrainingRevenueRow yang sudah final).
        this.new_daily_dpr_pt.day = 0
        this.new_daily_dpr_pt.month = 0
        const personalTrainingRows = data['Personal Training'] || []
        for (let pt = 0; pt < personalTrainingRows.length; pt++) {
          const el = personalTrainingRows[pt]
          this.new_daily_dpr_pt.day += el.total_day
          this.new_daily_dpr_pt.month += el.total_month
        }
      }).catch(error => {
        this.loadingActive = false
        this.loadingData = false
        console.log('error', error)
      })

      // target_collection — view_target_collection sudah period-scoped (tahun/bulan),
      // aman dipanggil live untuk periode manapun (closed atau tidak).
      let daily_dpr_target_collection_url = 'crm/v1/sales_report/daily_dpr_target_collection?tahun=' + moment(dates[0]).format('YYYY') + '&bulan=' + moment(dates[0]).format('MM')
      if (this.branch_id != null) {
        daily_dpr_target_collection_url += '&branch_id=' + this.branch_id
      }
      axios.get(daily_dpr_target_collection_url).then(response => {
        this.target_collection = response.data.data
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      // AUTO PAY & COLLECTION — v-if="autoPay.length" gate (sama seperti dailyDPR.vue,
      // data aktualnya tetap dari new_daily_dpr['Auto Pay'])
      axios.get('crm/v1/sales_report/daily_dpr_auto_pay?start=' + dates[0] + '&end=' + dates[1] + (this.branch_id != null ? '&branch_id=' + this.branch_id : '')).then(response => {
        this.loadingActive = false
        this.autoPay = response.data
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      // Production Performance (Cancellation/Freeze)
      let daily_dpr_cancellation_freeze_url = isClosedDprPeriod
        ? 'crm/v1/sales_report/daily_dpr_cancellation_freeze_history?period=' + dprPeriod
        : 'crm/v1/sales_report/daily_dpr_cancellation_freeze?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        daily_dpr_cancellation_freeze_url += '&branch_id=' + this.branch_id
      }
      axios.get(daily_dpr_cancellation_freeze_url).then(response => {
        this.loadingActive = false
        this.cancelFreeze = isClosedDprPeriod ? response.data.data : response.data
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      // Growth Performance
      let daily_dpr_growth_performance_url = isClosedDprPeriod
        ? 'crm/v1/sales_report/daily_dpr_growth_performance_history?period=' + dprPeriod
        : 'crm/v1/sales_report/daily_dpr_growth_performance?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        daily_dpr_growth_performance_url += '&branch_id=' + this.branch_id
      }
      axios.get(daily_dpr_growth_performance_url).then(response => {
        this.loadingActive = false
        this.growthPerformance = isClosedDprPeriod ? response.data.data : response.data
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      // Operation Performance
      let daily_dpr_operation_production_url = isClosedDprPeriod
        ? 'crm/v1/sales_report/daily_dpr_operation_production_history?period=' + dprPeriod
        : 'crm/v1/sales_report/daily_dpr_operation_production?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        daily_dpr_operation_production_url += '&branch_id=' + this.branch_id
      }
      axios.get(daily_dpr_operation_production_url).then(response => {
        this.loadingActive = false
        this.operationPerformance = isClosedDprPeriod ? response.data.data : response.data
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      // Total Revenue
      let daily_dpr_total_revenue_url = isClosedDprPeriod
        ? 'crm/v1/sales_report/daily_dpr_total_revenue_history?period=' + dprPeriod
        : 'crm/v1/sales_report/daily_dpr_total_revenue?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        daily_dpr_total_revenue_url += '&branch_id=' + this.branch_id
      }
      axios.get(daily_dpr_total_revenue_url).then(response => {
        this.loadingActive = false
        this.totalRevenueClub = response.data
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      // this.operation cuma dipakai sebagai gate v-if="operation.length" di seluruh
      // tabel box Operation (sama seperti dailyDPR.vue) — datanya sendiri tidak
      // ditampilkan (baris v-for aslinya sudah dikomentari di file lama).
      let daily_dpr_operation_url = 'crm/v1/sales_report/daily_dpr_operation?start=' + dates[0] + '&end=' + dates[1]
      if (this.branch_id != null) {
        daily_dpr_operation_url += '&branch_id=' + this.branch_id
      }
      axios.get(daily_dpr_operation_url).then(response => {
        this.loadingActive = false
        this.operation = response.data
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    }
  },
  created() {
    if (Auth.Session.get().paradigm_role == 3 || Auth.Session.get().paradigm_role == 4) {
      this.branch_id = Auth.Session.get().paradigm_branch_id
      this.disableBranch = true
    }

    this.fetchData()
  }
}
</script>

<style></style>
